/* Kopstorm size guide V2 (Oct 2026). Chart + fit picker inside the Size Guide drawer. */
(function () {
  if (window.__cdcSgV2) return;
  window.__cdcSgV2 = true;

  var STORE_KEY = 'cdc_sg_pick';
  var lastTrigger = null;

  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(window.localStorage.getItem(key) || 'null');
      window.localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }
  function fill(tpl, map) {
    return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] !== undefined ? map[k] : m; });
  }
  function esc(str) {
    return String(str).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function joinOr(list, word) {
    if (list.length < 2) return list.join('');
    return list.slice(0, -1).join(', ') + ' ' + word + ' ' + list[list.length - 1];
  }

  /* Preview override: ?cdc_sg=chart | chart-black | picker | picker-black | classic */
  function previewDesign() {
    var val = null;
    try {
      var p = new URLSearchParams(window.location.search).get('cdc_sg');
      if (p) { window.sessionStorage.setItem('cdc_sg', p); val = p; }
      else val = window.sessionStorage.getItem('cdc_sg');
    } catch (e) {}
    return val;
  }

  /* Intelligems test "Size Chart CDV_101": the variant sets data-cdc-sg on the
     html tag. Preview links win over the test, the section setting is the fallback. */
  function testDesign() {
    return document.documentElement.getAttribute('data-cdc-sg');
  }
  function applyDesign(modal) {
    if (!modal || modal.getAttribute('data-sg-has-chart') !== 'true') return;
    var val = previewDesign() || testDesign();
    if (!val) return;
    var parts = val.split('-');
    if (/^(chart|picker|classic)$/.test(parts[0])) modal.setAttribute('data-sg-design', parts[0]);
    modal.setAttribute('data-sg-accent', parts[1] === 'black' ? 'black' : 'gold');
  }
  function applyAll() {
    document.querySelectorAll('.sg__modal').forEach(applyDesign);
  }
  try {
    new MutationObserver(applyAll).observe(document.documentElement, { attributes: true, attributeFilter: ['data-cdc-sg'] });
  } catch (e) {}

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var t = e.target.closest('[data-open-size-guide]');
    if (t) { lastTrigger = t; return; }

    /* The product page "Size guide" link opens the old Size Guide page popup.
       When the V2 drawer is active, open the drawer instead. */
    var old = e.target.closest('modal-opener[data-modal^="size-chart-"], .size-chart-link');
    if (!old) return;
    applyAll();
    var v2 = document.querySelector('.sg__modal[data-sg-design="chart"], .sg__modal[data-sg-design="picker"]');
    if (!v2) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    lastTrigger = old;
    var opener = document.createElement('a');
    opener.href = '#';
    opener.setAttribute('data-open-size-guide', '');
    opener.hidden = true;
    document.body.appendChild(opener);
    opener.click();
    opener.remove();
    lastTrigger = old;
  }, true);

  function init(el) {
    if (el.__sgv2) return;
    el.__sgv2 = true;

    var modal = el.closest('.sg__modal');
    applyDesign(modal);

    var order = (el.getAttribute('data-size-order') || '').split(',');
    var bandThs = [].slice.call(el.querySelectorAll('.js-sgv2-band'));
    var cupThs = [].slice.call(el.querySelectorAll('.js-sgv2-cup'));
    var cells = [].slice.call(el.querySelectorAll('.sgv2__cell'));
    if (!bandThs.length || !cupThs.length) return;

    var grid = [];
    cells.forEach(function (c) {
      var b = +c.getAttribute('data-b'), ci = +c.getAttribute('data-c');
      (grid[ci] = grid[ci] || [])[b] = c;
    });

    var unit = el.getAttribute('data-unit') || 'in';
    var state = { b: 0, c: 0, fit: 'snug' };

    function bandLabel(b, u) { var th = bandThs[b]; return th ? th.getAttribute('data-' + (u || 'in')) : ''; }
    function cupLabel(c) { return cupThs[c] ? cupThs[c].textContent.trim() : ''; }
    function sizeAt(b, c) { var cell = grid[c] && grid[c][b]; return cell ? cell.getAttribute('data-size') : ''; }
    function findBand(label) { for (var i = 0; i < bandThs.length; i++) { if (bandLabel(i, 'in') === label || bandLabel(i, 'cm') === label) return i; } return -1; }
    function findCup(label) { for (var i = 0; i < cupThs.length; i++) { if (cupLabel(i).toUpperCase() === String(label).toUpperCase()) return i; } return -1; }

    /* Initial pick: remembered, else section default, else middle of the chart */
    var saved = store(STORE_KEY);
    var b0 = saved ? findBand(saved.band) : -1;
    var c0 = saved ? findCup(saved.cup) : -1;
    if (b0 < 0) b0 = findBand(el.getAttribute('data-default-band'));
    if (c0 < 0) c0 = findCup(el.getAttribute('data-default-cup'));
    state.b = b0 < 0 ? Math.floor(bandThs.length / 2) : b0;
    state.c = c0 < 0 ? Math.floor(cupThs.length / 2) : c0;

    var $ = function (sel) { return el.querySelector(sel); };
    var selectedEl = $('[data-sgv2-selected]');
    var sistersEl = $('[data-sgv2-sisters]');
    var bigEl = $('[data-sgv2-big]');
    var altEl = $('[data-sgv2-alt]');
    var basedEl = $('[data-sgv2-based]');
    var snugEl = $('[data-sgv2-snug]');
    var relaxedEl = $('[data-sgv2-relaxed]');
    var fitsEl = $('[data-sgv2-fits]');
    var naEl = $('[data-sgv2-na]');
    var ctaEl = $('[data-sgv2-cta]');

    function design() { return modal ? modal.getAttribute('data-sg-design') : 'chart'; }

    function sameSizeNeighbours(size) {
      var list = [];
      grid.forEach(function (row, c) {
        row.forEach(function (cell, b) {
          if (cell.getAttribute('data-size') === size && !(b === state.b && c === state.c)) {
            list.push({ b: b, c: c, d: Math.abs(b - state.b) + Math.abs(c - state.c) });
          }
        });
      });
      list.sort(function (x, y) { return x.d - y.d || x.b - y.b; });
      return list.slice(0, 2).map(function (o) { return bandLabel(o.b, 'in') + cupLabel(o.c); });
    }

    function sisterText() {
      var own = bandLabel(state.b, 'in') + cupLabel(state.c);
      var out = [];
      [[1, -1], [-1, 1]].forEach(function (d) {
        var b = state.b + d[0], c = state.c + d[1];
        if (b < 0 || c < 0 || b >= bandThs.length || c >= cupThs.length) return;
        var sz = sizeAt(b, c);
        out.push(bandLabel(b, 'in') + cupLabel(c) + (sz ? ' (' + sz + ')' : ''));
      });
      var tpl = el.getAttribute('data-sister') || 'Sister sizes hold the same cup volume on a tighter or looser band. For [bra] these are [sisters].';
      return out.length ? fill(tpl, { bra: own, sisters: joinOr(out, 'and') }) : '';
    }

    function relaxedSize(size) {
      var i = order.indexOf(size);
      return i > -1 && i < order.length - 1 ? order[i + 1] : '';
    }

    function activeSize() {
      var size = sizeAt(state.b, state.c);
      if (design() === 'picker' && state.fit === 'relaxed' && size) return relaxedSize(size) || size;
      return size;
    }

    function render() {
      var size = sizeAt(state.b, state.c);
      var band = bandLabel(state.b, 'in'), cup = cupLabel(state.c);

      cells.forEach(function (c) { c.classList.remove('is-on'); c.removeAttribute('aria-pressed'); });
      var cur = grid[state.c] && grid[state.c][state.b];
      if (cur) { cur.classList.add('is-on'); cur.setAttribute('aria-pressed', 'true'); }

      if (selectedEl) {
        selectedEl.innerHTML = esc(fill(el.getAttribute('data-selected'), { band: bandLabel(state.b, unit), cup: cup })) + ' <strong>' + esc(size || '/') + '</strong>';
      }
      if (sistersEl) sistersEl.textContent = sisterText();

      el.querySelectorAll('[data-sgv2-pills="band"] .sgv2__pill').forEach(function (p) {
        var on = +p.getAttribute('data-b') === state.b; p.classList.toggle('is-on', on); p.setAttribute('aria-pressed', on);
      });
      el.querySelectorAll('[data-sgv2-pills="cup"] .sgv2__pill').forEach(function (p) {
        var on = +p.getAttribute('data-c') === state.c; p.classList.toggle('is-on', on); p.setAttribute('aria-pressed', on);
      });

      if (bigEl) bigEl.textContent = size || '/';
      if (altEl) altEl.textContent = size ? joinOr([band + cup].concat(sameSizeNeighbours(size)), 'or') : '';
      if (basedEl) basedEl.textContent = fill(el.getAttribute('data-based'), { band: band, cup: cup });

      var rel = size ? relaxedSize(size) : '';
      if (snugEl) snugEl.textContent = size;
      if (relaxedEl) relaxedEl.textContent = rel;
      if (fitsEl) {
        fitsEl.hidden = !size;
        var relBtn = fitsEl.querySelector('[data-fit="relaxed"]');
        if (relBtn) relBtn.hidden = !rel;
        fitsEl.classList.toggle('is-single', !rel);
        if (!rel) state.fit = 'snug';
        fitsEl.querySelectorAll('.sgv2__fit').forEach(function (f) {
          var on = f.getAttribute('data-fit') === state.fit; f.classList.toggle('is-on', on); f.setAttribute('aria-pressed', on);
        });
      }
      if (naEl) {
        naEl.hidden = !!size;
        naEl.textContent = size ? '' : (el.getAttribute('data-unavailable') || '');
      }

      var act = activeSize();
      if (ctaEl) {
        ctaEl.disabled = !act;
        ctaEl.textContent = fill(el.getAttribute('data-cta'), { size: act || '/' });
      }
      store(STORE_KEY, { band: band, cup: cup });
    }

    /* Events */
    el.addEventListener('click', function (e) {
      var t = e.target;
      var cell = t.closest('.sgv2__cell');
      if (cell) {
        if (!cell.getAttribute('data-size')) return;
        state.b = +cell.getAttribute('data-b'); state.c = +cell.getAttribute('data-c'); render(); return;
      }
      var pill = t.closest('.sgv2__pill');
      if (pill) {
        if (pill.hasAttribute('data-b')) state.b = +pill.getAttribute('data-b');
        if (pill.hasAttribute('data-c')) state.c = +pill.getAttribute('data-c');
        state.fit = 'snug'; render(); return;
      }
      var fit = t.closest('.sgv2__fit');
      if (fit) { state.fit = fit.getAttribute('data-fit'); render(); return; }

      var u = t.closest('[data-sgv2-unit]');
      if (u) {
        unit = u.getAttribute('data-sgv2-unit');
        el.querySelectorAll('[data-sgv2-unit]').forEach(function (bt) {
          var on = bt === u; bt.classList.toggle('is-on', on); bt.setAttribute('aria-pressed', on);
        });
        bandThs.forEach(function (th) { th.textContent = th.getAttribute('data-' + unit) || th.getAttribute('data-in'); });
        render(); return;
      }

      var m = t.closest('[data-sgv2-measure]');
      if (m) {
        var body = $('[data-sgv2-measure-body]');
        if (body) { body.hidden = !body.hidden; m.setAttribute('aria-expanded', !body.hidden); }
        return;
      }

      if (t.closest('[data-sgv2-quiz]')) { openQuiz(); return; }
      if (t.closest('[data-sgv2-cta]')) { shop(activeSize()); }
    });

    function closeDrawer() {
      var x = modal && modal.querySelector('[data-sg-close]');
      if (x) x.click();
    }

    function openQuiz() {
      closeDrawer();
      setTimeout(function () {
        var q = document.querySelector('.sgq-trigger[data-sgq-open]');
        if (q) q.click();
        else window.location.href = el.getAttribute('data-quiz-url') || '/pages/fit-finder';
      }, 220);
    }

    /* Select the size on the product form the drawer was opened from */
    /* Chart says 2XL, products may say XXL: compare on a normalised name */
    function norm(v) {
      v = String(v || '').toUpperCase().replace(/\s+/g, '');
      var m = v.match(/^(X+)L$/);
      if (m && m[1].length > 1) return m[1].length + 'XL';
      return v;
    }

    function shop(size) {
      if (!size) return;
      size = norm(size);
      var optName = (el.getAttribute('data-size-option') || 'Size').toLowerCase();
      var scope = (lastTrigger && (lastTrigger.closest('.product-detail, .product-info, .product-form, form[action*="/cart/add"], .shopify-section'))) || document;
      function pickIn(root) {
        var sels = [].slice.call(root.querySelectorAll('.option-selector[data-option]')).filter(function (s) {
          return s.getAttribute('data-option').toLowerCase() === optName;
        });
        for (var i = 0; i < sels.length; i++) {
          /* Dropdown style: the theme custom-select */
          var cs = sels[i].querySelector('custom-select');
          if (cs && typeof cs.selectOption === 'function') {
            var opts = cs.querySelectorAll('.js-option[data-value]');
            for (var o = 0; o < opts.length; o++) {
              if (norm(opts[o].getAttribute('data-value')) === size) {
                cs.selectOption(opts[o]);
                return true;
              }
            }
          }
          var inputs = sels[i].querySelectorAll('input[type="radio"]');
          for (var j = 0; j < inputs.length; j++) {
            if (norm(inputs[j].value) === size) {
              if (!inputs[j].checked) inputs[j].click();
              return true;
            }
          }
          var sel = sels[i].querySelector('select');
          if (sel) {
            for (var k = 0; k < sel.options.length; k++) {
              if (norm(sel.options[k].value) === size) {
                sel.value = sel.options[k].value;
                sel.dispatchEvent(new Event('change', { bubbles: true }));
                return true;
              }
            }
          }
        }
        return false;
      }
      var done = pickIn(scope) || (scope !== document && pickIn(document));
      if (done || document.querySelector('form[action*="/cart/add"]')) { closeDrawer(); return; }
      window.location.href = el.getAttribute('data-cta-fallback') || '/collections/bras';
    }

    /* Opening an accordion or the measuring steps scrolls its content into view */
    var scroller = $('.sgv2__body');
    function reveal(target) {
      if (!scroller || !target) return;
      setTimeout(function () {
        var top = target.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - 8;
        scroller.scrollTo({ top: top, behavior: 'smooth' });
      }, 30);
    }
    el.querySelectorAll('.sgv2__acc').forEach(function (d) {
      d.addEventListener('toggle', function () { if (d.open) reveal(d); });
    });
    var mLink = $('[data-sgv2-measure]');
    if (mLink) mLink.addEventListener('click', function () {
      setTimeout(function () { if (mLink.getAttribute('aria-expanded') === 'true') reveal(mLink); }, 0);
    });

    render();
  }

  function boot() { document.querySelectorAll('[data-sgv2]').forEach(init); applyAll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
